<template>
  <div class="wrapper-list">
    <app-bar-navigation is-white hide-navigation :title="$t('pick_country')" />
    <div class="wrapper-content">
      <q-column>
        <q-spacer horizontal="sm">
          <q-input v-model="search" :border="true" :placeholder="$t('search_country')" variant="formal" label=" " />
        </q-spacer>
        <q-spacer horizontal="sm" top="xs">
          <div class="list-groups">
            <div class="list-item" v-for="(country, key) in countries" :key="key" @click="updateCountry(country)">
              <q-row alignItems="center">
                <q-column flex="2">
                  <q-row alignItems="center">
                    <img :src="flagCountry(country.name)" :alt="country.name" />
                    <q-text variant="ui-baseline">
                      {{ country.phoneCode }}
                    </q-text>
                  </q-row>
                </q-column>
                <q-column flex="4">
                  <q-text variant="ui-baseline">
                    {{ country.name }}
                  </q-text>
                </q-column>
              </q-row>
            </div>
          </div>
        </q-spacer>
      </q-column>
    </div>
  </div>
</template>

<script>
import {
  AppBarNavigation,
  Column as QColumn,
  Row as QRow,
  Spacer as QSpacer,
  Padder as QPadder,
  InputField as QInput,
  Text as QText
} from '@qoala/ui';

import list from '@/static/data/countryList.json';

export default {
  name: 'ToolPickCountries',

  components: {
    AppBarNavigation,
    QColumn,
    QRow,
    QSpacer,
    QPadder,
    QInput,
    QText
  },

  data() {
    return {
      search: '',
      filterKey: '#',
      listFilter: '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    };
  },

  computed: {
    countries() {
      const filteredCountries = list.filter(country => {
        const key = this.search.toLowerCase();
        const filterKey = this.filterKey.toLowerCase();
        const name = country.name.toLowerCase();
        if (filterKey !== '#') {
          return name[0] === filterKey && name.indexOf(key) >= 0;
        }
        return name.indexOf(key) >= 0;
      });
      return filteredCountries;
    }
  },

  methods: {
    updateCountry(data) {
      this.$emit('clicked', false);
      this.$emit('input', data);
    },
    flagCountry(data) {
      if (data.length > 0) {
        return `/images/icons/flags/${data.replace(/ /g, '_')}.png`;
      }
      return this.computedCountry.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper-list {
  position: fixed;
  z-index: 9999;
  background: #f6f9ff;
  width: 100%;
  left: 0;
  top: 0;
  .wrapper-content {
    overflow-x: hidden;
    padding: 56px 0 0 !important;
    height: 100vh;
  }
}
.list-groups {
  position: relative;
  padding: 10px 0;
  .list-item {
    padding: 10px;
    cursor: pointer;
    -webkit-overflow-scrolling: touch;
    &:nth-child(even) {
      background: #fff;
    }
    img {
      max-height: 35px;
      max-width: 35px;
      height: 100%;
      width: 100%;
      background: #d3d3d3;
      margin-right: 10px;
    }
  }
}
</style>
